import { trackEvent } from '../../analytics/analyticsTracker';

export function trackSubmitLatency(
  durationMs: number,
  status: number,
  url: string,
  requestSize: string,
  responseSize: string
): void {
  trackEvent({
    eventName: 'survey_submit_latency',
    metadata: {
      durationMs,
      status,
      success: true,
      url,
      requestSize,
      responseSize,
    },
  });
}

export function trackSubmitError(status: number | string, url: string, errorMessage: string): void {
  trackEvent({
    eventName: 'api_error',
    metadata: {
      apiName: 'POST Submit Response',
      status,
      url,
      errorMessage,
    },
  });
}
